import React, { useCallback, useEffect, useState } from "react";
import { HTTPStatusType } from "../http_status_type";

const useAxiosFetch = (props) => {
  const [request, setRequest] = useState(null);
  const [responseData, setResponseData] = useState(null);
  const onRequestChange = (mode) => {
    setRequest({ mode });
  };

  const onFetch = useCallback(async (values) => {
    onRequestChange(HTTPStatusType.PENDING);
    try {
      const response = await props.fetcher(values);
      props?.onSuccess && props.onSuccess(response, values);
      setResponseData(response.data);
      onRequestChange(HTTPStatusType.FULFILLED);
    } catch (error) {
      console.log("DJKLJ", error)
      props.onError && props.onError(error);
      onRequestChange(HTTPStatusType.REJECTED);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (props.fetchOnce) {
      onFetch();
    }
  }, [onFetch, props.fetchOnce]);

  return {
    onFetch,
    status: request?.mode,
    responseData,
    success: request?.mode === HTTPStatusType.FULFILLED,
    loading: request?.mode === HTTPStatusType.PENDING,
  };
};

export default useAxiosFetch;
